
import ForumPostDetail from '../../components/ForumPostDetail';

export default function ReviewsDetailPage() {
  return <ForumPostDetail categoryId="reviews" />;
}
